import { render, staticRenderFns } from "./actualizarPassword.vue?vue&type=template&id=7a33882e&"
import script from "./actualizarPassword.vue?vue&type=script&lang=js&"
export * from "./actualizarPassword.vue?vue&type=script&lang=js&"
import style0 from "./actualizarPassword.scss?vue&type=style&index=0&prod&lang=scss&"
import style1 from "../../../App.scss?vue&type=style&index=1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports